import { Button, SpinnerInline } from '@vst/beam';
import { ButtonVariants } from '@vst/beam/src/react/Button/Button';

export const SpinnerButton = ({
  loading,
  label,
  variant,
  disabled,
  type,
  fluid,
  handleClick,
}: {
  loading: boolean;
  label: string;
  variant: ButtonVariants;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  fluid?: boolean;
  handleClick: () => void;
}) => {
  return (
    <Button
      fluid={fluid}
      type={type}
      variant={variant}
      disabled={disabled}
      onClick={handleClick}
      data-cy="spinner-button"
    >
      {loading ? <SpinnerInline label={label} /> : label}
    </Button>
  );
};
